import JourneyEventBuffer from "./JourneyEventBuffer";

/**
 * Centralized tab switch tracking for journey events.
 */
export function trackTabSwitch(entityType, fromTab, toTab) {
  if (!entityType) return;
  try {
    JourneyEventBuffer.track("tab_switch", {
      event_data: {
        entity_type: entityType,
        from_tab: fromTab ?? null,
        to_tab: toTab ?? null,
        tab_name: toTab ?? null,
      },
    });
  } catch (e) {
    // Never break the app for tracking
  }
}
